import EnumCommon from './EnumCommon';
class EmailAvailabilityStatus extends EnumCommon {
    labels() {
        return {
            [1]: 'AVAILABLE',
            [2]: 'BUSY',
            [3]: 'ALREADY_IN_ENTITY',
            [4]: 'IN_OTHER_ENTITY',
        };
    }
}
EmailAvailabilityStatus.NAME = 'EmailAvailabilityStatus';
EmailAvailabilityStatus.AVAILABLE = new EmailAvailabilityStatus(1);
EmailAvailabilityStatus.BUSY = new EmailAvailabilityStatus(2);
EmailAvailabilityStatus.ALREADY_IN_ENTITY = new EmailAvailabilityStatus(3);
EmailAvailabilityStatus.IN_OTHER_ENTITY = new EmailAvailabilityStatus(4);
export default EmailAvailabilityStatus;
